import React from 'react'
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast'
import Loader from '../../Components/Loader/Loader'
import {getAuth, onAuthStateChanged} from 'firebase/auth'
import {getStorage, ref, uploadBytesResumable, getDownloadURL} from 'firebase/storage'
import { db } from '../../Components/Firebase/firebase.config'
import {addDoc, collection, serverTimestamp, doc, getDoc, setDoc, query, onSnapshot} from 'firebase/firestore'
import { UserContext } from '../../Context/context';

const RequestForm = ({setLoading}) => {
  const {user, setUser} = React.useContext(UserContext)
  const [formData, setData] = React.useState({
    name: user.displayName,
    email: user.email,
    courseName: '',
    courseLink: '',
    likes: 0,
    dislikes: 0,
    hasLiked:[],
    hasDisliked:[]
  })

  const handleFormSubmit = async (e) => {
    setLoading(true);
    e.preventDefault()
    const docRef = await addDoc(collection(db, 'request'), formData)

    setLoading(false)
    toast.success('Added Successfully')

  }


  return (
    <div className="request">
     <form onSubmit={handleFormSubmit}>
    <input type="text" placeholder="Name" value={user.displayName} readOnly/>
    <input type="email" placeholder="Email Address" value={user.email} readOnly/>
    <input type="text" placeholder="Course Name" value={formData.courseName} onChange={e=> setData({...formData, courseName: e.target.value})}/>
    <input type="text" placeholder="Course Link" value={formData.courseLink} onChange={e=> setData({...formData, courseLink: e.target.value})}/>
    <input type="submit" value="Submit"/>
  </form>
    </div>
  )
}

export default RequestForm